import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-05/lesson-24/task-01";

const task: Slide = {
  title: "Please examine the party wall detail of a lightweight timber constuction and answer the question below.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [3, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/24/task/task-1.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
